import React from 'react'
import {Col, Row} from 'react-bootstrap'
import {KTSVG} from '../../../../_metronic/helpers'

type Props = {}

const BusinessCentricContent = (props: Props) => {
  return (
    <div className='container d-flex- justify-content-center '>
      <div className='bg-white py-10 text-center container'>
        <div className='fw-bolder display-4 p-6 pt-lg-10'>Why Businesses Choose Lucian</div>
        <Row className='mt-10 d-flex justify-content-center  '>
          <Col md='4' className='d-flex flex-column justify-content-center'>
            <div className='d-flex justify-content-start align-items-center'>
              <div className='bg-light-primary px-2 py-3 rounded'>
                <KTSVG
                  path='/media/icons/duotune/general/bolt.svg'
                  className='svg-icon-4x ms-n1 svg-icon-primary '
                />
              </div>
              <span className='mx-3 text-dark fw-bolder fs-3'>speed</span>
            </div>
            <div className='my-8 d-flex justify-content-center flex-column text-start'>
              <span className='fw-bold text-primary fs-1  '>5 days</span>
              <span className='mt-0 fs-5'>to fill most roles, sometimes same day.</span>
            </div>
          </Col>
          <Col md='4' className=' d-flex flex-column justify-content-center '>
            <div className='d-flex justify-content-start align-items-center'>
              <div className='bg-light-primary px-2 py-3 rounded'>
                <KTSVG
                  path='/media/icons/duotune/general/gen012.svg'
                  className='svg-icon-4x ms-n1 svg-icon-primary '
                />
              </div>
              <span className='mx-3 text-dark fw-bolder fs-3'>Time Saved</span>
            </div>
            <div className='my-8 d-flex justify-content-center flex-column text-start'>
              <span className='fw-bold text-primary fs-1  '>50+ hours</span>
              <span className='mt-0 fs-5'>
                of engineering team time saved per hire on interviewing.
              </span>
            </div>
          </Col>
          <Col md='4' className=' d-flex flex-column justify-content-start'>
            <div className='d-flex justify-content-start align-items-center'>
              <div className='bg-light-primary px-2 py-3 rounded'>
                <KTSVG
                  path='/media/icons/duotune/general/gen048.svg'
                  className='svg-icon-4x ms-n1 svg-icon-primary '
                />
              </div>
              <span className='mx-3 text-dark fw-bolder fs-3'>Gurantee</span>
            </div>
            <div className='my-8 d-flex justify-content-center flex-column text-start'>
              <span className='fw-bold text-primary fs-1  '>100% Success rate</span>
              <span className='mt-0 fs-5'>
                Your project is will be fully completed without any delays{' '}
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default BusinessCentricContent
